/**
 * @module utils/columnSort/syncFromQB/syncPercentage
 * @description column_percentage 变更时同步 % 虚拟列（对齐旧 watchPercentageColumnChange）
 */

import type { IColumnSortItem } from '@/pages/datalab/pages/Multidimensional/Analysis/types/chartSettings/fieldColumnSort';
import type { IColumnPercentageItem } from '../untils/columnPercentage';
import { isDimPctVirtualColumn } from '../untils/dimensionPercentage';
import { isPercentVirtualColumn, percentColumnForMetric } from '../untils/fieldUtils';
import {
  isColumnSortDimension,
  isCompareUserFilterColumn,
  stripPercentagePrefix,
} from '../untils/keys';

export type { IColumnPercentageItem } from '../untils/columnPercentage';

function percentageKey(item: IColumnPercentageItem): string {
  return `${item.table_code || 't0'}::${item.metric}`;
}

/**
 * 已持久化 column_sort 时：移除无效 % 列，再按 column_percentage 在主指标后插入
 */
export function applyPercentVirtualColumns(
  list: IColumnSortItem[],
  columnPercentage: IColumnPercentageItem[],
): IColumnSortItem[] {
  const needKeys = new Set(columnPercentage.map(percentageKey));
  const existingPctKeys = new Set<string>();

  const filtered = list.filter(item => {
    if (
      isCompareUserFilterColumn(item.column) ||
      item.is_compare_date ||
      isColumnSortDimension(item)
    ) {
      return true;
    }
    if (!isPercentVirtualColumn(item)) {
      return true;
    }
    const base = stripPercentagePrefix(item.column);
    const key = `${item.table_code || 't0'}::${base}`;
    if (needKeys.has(key)) {
      existingPctKeys.add(`${item.table_code || 't0'}_${base}`);
      return true;
    }
    return false;
  });

  const next: IColumnSortItem[] = [];

  filtered.forEach(item => {
    next.push(item);
    if (
      isColumnSortDimension(item) ||
      isPercentVirtualColumn(item) ||
      isDimPctVirtualColumn(item)
    ) {
      return;
    }
    const metricName = item.column || '';
    if (!metricName) {
      return;
    }
    const tableCode = item.table_code || 't0';
    const key = `${tableCode}_${metricName}`;
    const pctConfigKey = `${tableCode}::${metricName}`;
    if (!needKeys.has(pctConfigKey) || existingPctKeys.has(key)) {
      return;
    }
    const pct = percentColumnForMetric(
      metricName,
      item.column_display_cn || metricName,
      item.column_display_en || item.column_display_cn || metricName,
    );
    next.push({
      ...item,
      ...pct,
      table_id: item.table_id,
      table_code: tableCode,
    });
    existingPctKeys.add(key);
  });

  return next;
}
